import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ApplicationActions, ApplicationFacade } from './+state';
import { ApplicationService } from './application.service';


@NgModule({
    declarations: [],
    imports: [
        CommonModule
    ],
    providers: [ ApplicationService, ApplicationActions, ApplicationFacade ]
})
export class ApplicationModule {}
